/* ==========================================================================
   SD Berater PV-Anlage · Bundle-Ergebnis (Set + Speicher / Sunbooster)
   Auswahl-Checkboxen + Sammel-Warenkorb, Dach->Set-Variante, Skip-Logik
   Doppelstabzaun (ort=Freifläche): Zaunlänge -> Felder (2,5 m/Feld, aufgerundet).
   Pro Feld werden IMMER 6 Streifen montiert (Verkabelung) -> 1x 6er-Set/Feld.
   Wechselrichter (nur "Mit Wechselrichter"): passendes Produkt aus "feldTiers"
   je nach Feld-Anzahl (siehe Section-Liquid für die Stufen).
   Schieberegler-Fragen: Stufen aus "Regler-Stufen" (Label|Wert;...) oder
   Antworten 1-4.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY_FALLBACK = '{{amount_with_comma_separator}} €';
  var MATTE_BREITE_M = 2.5;   // Breite eines Zaun-Felds (Doppelstabmatte)
  var STREIFEN_PRO_FELD = 6;  // Immer 6 Streifen pro Feld (Verkabelung)

  function formatMoney(cents, format) {
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = intPart + ',' + parts[1];
    return (format || MONEY_FALLBACK).replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function contains(hay, needle) {
    return String(hay).toLowerCase().indexOf(String(needle).toLowerCase().trim()) !== -1;
  }

  function toNumber(v) {
    return parseFloat(String(v).replace(',', '.')) || 0;
  }

  function Sdb(root) {
    this.root = root;
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-sdb-step]'));
    this.resultEl = root.querySelector('[data-sdb-result]');
    this.stageEl = root.querySelector('[data-sdb-stage]');
    this.fillEl = root.querySelector('[data-sdb-fill]');
    this.pctEl = root.querySelector('[data-sdb-pct]');
    this.counterEl = root.querySelector('[data-sdb-counter]');
    this.headEl = root.querySelector('[data-sdb-head]');
    this.navEl = root.querySelector('[data-sdb-nav]');
    this.backBtn = root.querySelector('[data-sdb-back]');
    this.fwdBtn = root.querySelector('[data-sdb-forward]');
    this.productsEl = root.querySelector('[data-sdb-products]');
    this.bulkEl = root.querySelector('[data-sdb-bulk]');
    this.moneyFormat = root.dataset.sdbMoneyFormat || MONEY_FALLBACK;
    this.emptyText = root.dataset.sdbEmpty || '';
    /* TEST: Ergebnis-Erklaerung ein/aus (Section-Setting "debug_ergebnis") */
    this.debug = root.dataset.sdbDebug === 'true';

    try {
      this.config = JSON.parse(root.querySelector('[data-sdb-config]').textContent) || {};
    } catch (e) {
      this.config = {};
    }

    this.index = 0;
    this.answers = {};
    this.setupSliders();
    this.bind();
    this.render('fwd');
  }

  Sdb.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-sdb-option]');
      if (opt && self.root.contains(opt)) { self.choose(opt); return; }
      var bulk = event.target.closest('[data-sdb-bulk-atc]');
      if (bulk && self.root.contains(bulk)) { self.addSelected(bulk); }
    });
    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-sdb-pick-box]')) self.updateSum();
    });
    if (this.backBtn) this.backBtn.addEventListener('click', function () { self.back(); });
    if (this.fwdBtn) this.fwdBtn.addEventListener('click', function () { self.forward(); });
    var restart = this.root.querySelector('[data-sdb-restart]');
    if (restart) restart.addEventListener('click', function () { self.restart(); });
  };

  /* --- Schieberegler-Darstellung (data-sdb-slider) ---------------------- */
  Sdb.prototype.setupSliders = function () {
    var self = this;
    this.steps.forEach(function (step) {
      if (step.dataset.sdbSlider !== 'true') return;
      var grid = step.querySelector('.sdb__grid');
      if (grid) grid.style.display = 'none';
      var buttons = Array.prototype.slice.call(step.querySelectorAll('[data-sdb-option]'));

      var wrap = document.createElement('div');
      wrap.className = 'sdb__slider';

      var valueEl = document.createElement('div');
      valueEl.className = 'sdb__sliderValue';
      var valueMain = document.createElement('b');
      var valueSub = document.createElement('span');
      valueEl.appendChild(valueMain);
      valueEl.appendChild(valueSub);

      var range = document.createElement('input');
      range.type = 'range';
      range.className = 'sdb__sliderRange';
      range.min = '0';
      range.max = '1';
      range.step = '1';
      range.value = '0';
      var q = step.querySelector('.sdb__q');
      range.setAttribute('aria-label', q ? q.textContent.trim() : 'Auswahl');

      var ticksEl = document.createElement('div');
      ticksEl.className = 'sdb__sliderTicks';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'sdb__sliderNext';
      next.textContent = 'Weiter ›';
      next.addEventListener('click', function () { self.goNext(); });

      var stops = [];
      var tickEls = [];
      var idx = 0;

      function resolveStops() {
        var raw = step.dataset.sdbStops || '';
        if (raw.trim() !== '') {
          return raw.split(';').map(function (e) {
            var p = e.split('|');
            var lab = (p[0] || '').trim();
            return { label: lab, value: (p[1] || lab).trim(), tick: lab.split('·')[0].trim() };
          }).filter(function (s) { return s.label !== ''; });
        }
        return buttons.map(function (o) {
          var lab = o.dataset.sdbLabel || '';
          return { label: lab, value: o.dataset.sdbValue || lab, tick: lab.split('·')[0].trim(), btn: o };
        });
      }

      function apply(i) {
        if (!stops.length) return;
        idx = Math.max(0, Math.min(stops.length - 1, i));
        range.value = String(idx);
        var s = stops[idx];
        var parts = s.label.split('·');
        valueMain.textContent = parts[0].trim();
        valueSub.textContent = (parts[1] || '').trim();
        var pct = stops.length > 1 ? (idx / (stops.length - 1)) * 100 : 0;
        range.style.backgroundSize = pct + '% 100%';
        buttons.forEach(function (el) {
          el.setAttribute('aria-pressed', s.btn === el ? 'true' : 'false');
        });
        tickEls.forEach(function (el, j) { el.dataset.active = j === idx ? 'true' : 'false'; });
        self.answers[step.dataset.sdbKey] = { label: s.label, value: s.value };
      }

      function refresh(reset) {
        stops = resolveStops();
        if (!stops.length) return;
        range.max = String(Math.max(1, stops.length - 1));
        range.disabled = stops.length < 2;
        ticksEl.innerHTML = '';
        tickEls = stops.map(function (s, j) {
          var t = document.createElement('span');
          t.textContent = s.tick;
          t.addEventListener('click', function () { apply(j); });
          ticksEl.appendChild(t);
          return t;
        });
        apply(reset ? 0 : idx);
      }

      range.addEventListener('input', function () { apply(parseInt(this.value, 10) || 0); });

      wrap.appendChild(valueEl);
      wrap.appendChild(range);
      wrap.appendChild(ticksEl);
      wrap.appendChild(next);
      if (grid && grid.parentNode) grid.parentNode.insertBefore(wrap, grid.nextSibling);

      step._sdbSliderRefresh = refresh;
      step._sdbSliderReset = function () { refresh(true); };
      refresh(true);
    });
  };

  Sdb.prototype.current = function () { return this.steps[this.index]; };

  Sdb.prototype.matchAnswer = function (key, value) {
    // value darf eine Komma-Liste sein, z. B. "Gewerbe,Freifläche"
    var a = this.answers[key];
    if (!a) return false;
    var label = String(a.label).toLowerCase().trim();
    var val = String(a.value).toLowerCase().trim();
    return String(value).split(',').some(function (want) {
      want = want.toLowerCase().trim();
      return want !== '' && (val === want || label === want);
    });
  };

  Sdb.prototype.shouldSkip = function (step) {
    // "Ueberspringen wenn": Schritt ueberspringen, wenn answer[key] == value
    var sk = step.dataset.sdbSkipKey;
    var sv = step.dataset.sdbSkipValue;
    if (sk && sv && this.matchAnswer(sk, sv)) return true;
    // "Nur anzeigen wenn": Schritt ueberspringen, ausser answer[key] == value
    var ok = step.dataset.sdbOnlyKey;
    var ov = step.dataset.sdbOnlyValue;
    if (ok && ov && !this.matchAnswer(ok, ov)) return true;
    return false;
  };

  Sdb.prototype.visibleSteps = function () {
    var self = this;
    return this.steps.filter(function (s) { return !self.shouldSkip(s); });
  };

  Sdb.prototype.nextIndex = function (from) {
    var i = from + 1;
    while (i < this.steps.length && this.shouldSkip(this.steps[i])) i++;
    return i;
  };
  Sdb.prototype.prevIndex = function (from) {
    var i = from - 1;
    while (i >= 0 && this.shouldSkip(this.steps[i])) i--;
    return i;
  };

  Sdb.prototype.choose = function (button) {
    var step = button.closest('[data-sdb-step]');
    var key = step.dataset.sdbKey;
    this.answers[key] = {
      label: button.dataset.sdbLabel || '',
      value: button.dataset.sdbValue || button.dataset.sdbLabel || ''
    };
    Array.prototype.forEach.call(step.querySelectorAll('[data-sdb-option]'), function (el) {
      el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
    });
    var self = this;
    window.setTimeout(function () { self.goNext(); }, 180);
  };

  Sdb.prototype.goNext = function () {
    var n = this.nextIndex(this.index);
    if (n >= this.steps.length) this.showResult();
    else { this.index = n; this.render('fwd'); }
  };

  Sdb.prototype.forward = function () {
    var step = this.current();
    if (!step) return;
    if (step.dataset.sdbRequired === 'true' && !this.answers[step.dataset.sdbKey]) {
      var o = step.querySelector('[data-sdb-option]'); if (o) o.focus();
      return;
    }
    this.goNext();
  };

  Sdb.prototype.back = function () {
    if (this.resultEl && this.resultEl.dataset.active === 'true') {
      this.resultEl.dataset.active = 'false';
      this.headEl.hidden = false; this.stageEl.hidden = false; this.navEl.hidden = false;
      this.render('back');
      return;
    }
    var p = this.prevIndex(this.index);
    if (p >= 0) { this.index = p; this.render('back'); }
  };

  Sdb.prototype.restart = function () {
    this.index = 0;
    this.answers = {};
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-sdb-option]'), function (el) {
      el.setAttribute('aria-pressed', 'false');
    });
    if (this.resultEl) this.resultEl.dataset.active = 'false';
    this.headEl.hidden = false; this.stageEl.hidden = false; this.navEl.hidden = false;
    this.steps.forEach(function (step) { if (step._sdbSliderReset) step._sdbSliderReset(); });
    this.render('fwd');
  };

  Sdb.prototype.render = function (direction) {
    this.root.classList.toggle('sdb--fwd', direction === 'fwd');
    this.root.classList.toggle('sdb--back', direction === 'back');
    var self = this;
    this.steps.forEach(function (step, i) {
      var active = i === self.index;
      step.dataset.active = active ? 'true' : 'false';
      step.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    var step = this.current();
    // Dynamische Slider-Stufen (z. B. Streifen pro Matte) aktualisieren
    if (step && step._sdbSliderRefresh) step._sdbSliderRefresh(false);
    // Zaehler & Fortschritt dynamisch aus den sichtbaren Schritten
    var vis = this.visibleSteps();
    var num = vis.indexOf(step) + 1;
    if (num < 1) num = 1;
    var total = Math.max(vis.length, num);
    var pct = total > 0 ? Math.round(((num - 1) / total) * 100) : 0;
    this.fillEl.style.width = pct + '%';
    this.fillEl.parentElement.setAttribute('aria-valuenow', String(pct));
    this.pctEl.textContent = pct + '% fertig';
    this.counterEl.textContent = num + ' von ' + total;
    this.backBtn.hidden = this.prevIndex(this.index) < 0;
  };

  /* --- Ergebnis-Zusammenstellung --------------------------------------- */
  Sdb.prototype.pickVariant = function (product, keyword) {
    if (!product || !product.variants || !product.variants.length) return null;
    var i;
    if (keyword) {
      for (i = 0; i < product.variants.length; i++) {
        if (contains(product.variants[i].title, keyword)) return product.variants[i];
      }
    }
    for (i = 0; i < product.variants.length; i++) {
      if (contains(product.variants[i].title, 'ohne')) return product.variants[i];
    }
    return product.variants[0];
  };

  Sdb.prototype.buildItems = function () {
    var cfg = this.config;
    var products = cfg.products || {};
    var labels = cfg.labels || {};
    var items = [];
    /* TEST: Erklaerungs-Zeilen fuer die Ergebnis-Anzeige sammeln */
    var ex = this._explain = [];

    function pushHandle(handle, qty, kat) {
      var p = products[handle];
      if (p && p.variants && p.variants[0] && qty > 0) {
        items.push({ kat: kat, product: p, variant: p.variants[0], qty: qty });
      }
    }

    var ort = this.answers['ort'];
    if (ort && contains(ort.value, 'freifläche')) {
      var kat = labels.freiflaeche || 'Sunbooster';
      var zs = cfg.zaunsets || {};
      var wr = this.answers['wr'];
      var laenge = this.answers['laenge'];

      var l = laenge ? toNumber(laenge.value) : 0;
      var felder = l > 0 ? Math.ceil(l / MATTE_BREITE_M) : 0;

      /* TEST: Erklaerung Zaun-Pfad */
      ex.push('Auswahl „' + ort.label + '“ (interner Wert: ' + ort.value + ') → Zaun-Konfiguration');
      if (laenge) ex.push('Zaunlänge ' + l + ' m ÷ 2,5 m je Feld = ' + felder + ' Felder (aufgerundet)');

      if (felder > 0) {
        // Pro Feld werden IMMER 6 Streifen montiert (Verkabelung) -> 1x 6er-Set/Feld
        ex.push('Pro Feld werden immer ' + STREIFEN_PRO_FELD + ' Streifen montiert (Verkabelung) → ' + felder + '× 6er-Set');
        pushHandle(zs.s6, felder, kat);

        if (wr) {
          if (contains(wr.value, 'mit')) {
            var tiers = cfg.feldTiers || [];
            var tier = null;
            for (var i = 0; i < tiers.length; i++) {
              if (felder >= tiers[i].min && felder <= tiers[i].max) { tier = tiers[i]; break; }
            }
            if (tier && tier.handle) {
              ex.push(felder + ' Felder → passender Wechselrichter: ' + (tier.label || tier.handle));
              pushHandle(tier.handle, 1, labels.wechselrichter || 'Wechselrichter');
            } else if (tier) {
              ex.push('Hinweis: Für ' + felder + ' Felder (' + tier.label + ') ist noch kein Wechselrichter-Produkt hinterlegt.');
            } else {
              ex.push('Hinweis: Für ' + felder + ' Felder ist keine Wechselrichter-Stufe definiert (max. 40 Felder unterstützt).');
            }
          } else {
            ex.push('Ohne Wechselrichter → nur Streifen-Sets, kein Wechselrichter im Ergebnis');
          }
        }
        return items;
      }

      /* TEST */ ex.push('Hinweis: Fragen unvollständig beantwortet → Standard-Produktliste (Fallback)');

      // Fallback (Fragen nicht konfiguriert): bisheriges Verhalten
      (cfg.freiflaeche || []).forEach(function (h) {
        pushHandle(h, 1, kat);
      });
      return items;
    }

    var size = this.answers['groesse'];
    var slot = size && cfg.sizes ? cfg.sizes[String(size.value)] : null;
    /* TEST: Erklaerung Haus/Gewerbe-Pfad */
    if (ort) ex.push('Auswahl „' + ort.label + '“ → Dach-Anlage');
    if (size) ex.push('Größe „' + size.label + '“ (Wert ' + size.value + ' kW) → Komplettset-Zuordnung');
    if (slot) {
      var setP = products[slot.set];
      var roof = this.answers['dach'];
      var v = this.pickVariant(setP, roof ? roof.value : '');
      if (setP && v) items.push({ kat: labels.set || 'Komplettset', product: setP, variant: v, qty: 1 });
      /* TEST */ ex.push('Set-Produkt: ' + slot.set + (roof && v ? ' · Dach „' + roof.value + '“ → Variante „' + v.title + '“' : ''));

      var sp = this.answers['speicher'];
      if (sp && contains(sp.value, 'mit') && slot.speicher) {
        var spP = products[slot.speicher];
        if (spP && spP.variants && spP.variants[0]) {
          items.push({ kat: labels.speicher || 'Stromspeicher', product: spP, variant: spP.variants[0], qty: 1 });
          /* TEST */ ex.push('Mit Stromspeicher → passender Speicher: ' + slot.speicher);
        }
      } else if (sp) {
        /* TEST */ ex.push('Ohne Stromspeicher → kein Speicher im Ergebnis');
      }
    }
    return items;
  };

  /* === TEST: Ergebnis-Erklaerung ============================================
     Zum Entfernen: diese Methode, den Aufruf this.renderDebug() in showResult,
     alle mit "TEST" markierten Zeilen, den CSS-Block .sdb__debug in der Section
     und das Section-Setting "debug_ergebnis" loeschen.
     Zum Ausblenden reicht: Haken "TEST: Ergebnis-Erklaerung" im Theme-Editor raus.
     ========================================================================= */
  Sdb.prototype.renderDebug = function () {
    var old = this.resultEl.querySelector('[data-sdb-debug-box]');
    if (old) old.remove();
    if (!this.debug || !this._explain || !this._explain.length) return;
    var dbg = document.createElement('div');
    dbg.className = 'sdb__debug';
    dbg.setAttribute('data-sdb-debug-box', '');
    var head = document.createElement('b');
    head.textContent = 'Warum dieses Ergebnis? (Test-Anzeige – im Theme-Editor abschaltbar)';
    dbg.appendChild(head);
    this._explain.forEach(function (line) {
      var row = document.createElement('div');
      row.textContent = '• ' + line;
      dbg.appendChild(row);
    });
    if (this.bulkEl && this.bulkEl.parentNode) this.bulkEl.parentNode.insertBefore(dbg, this.bulkEl);
    else this.productsEl.appendChild(dbg);
  };

  Sdb.prototype.showResult = function () {
    if (!this.resultEl) return;
    this.renderItems(this.buildItems());
    this.renderDebug(); /* TEST */
    this.headEl.hidden = true; this.stageEl.hidden = true; this.navEl.hidden = true;
    this.resultEl.dataset.active = 'true';
    this.resultEl.focus({ preventScroll: true });
  };

  Sdb.prototype.renderItems = function (items) {
    var self = this;
    this.productsEl.innerHTML = '';

    if (!items.length) {
      if (this.bulkEl) this.bulkEl.hidden = true;
      var wrap = document.createElement('div');
      wrap.className = 'sdb__emptyWrap';
      var empty = document.createElement('p');
      empty.className = 'sdb__empty';
      empty.textContent = this.emptyText;
      wrap.appendChild(empty);
      this.productsEl.appendChild(wrap);
      return;
    }

    items.forEach(function (it) {
      var v = it.variant;
      var qty = it.qty || 1;
      var label = document.createElement('label');
      label.className = 'sdb__pick';

      var box = document.createElement('input');
      box.type = 'checkbox';
      box.className = 'sdb__pickBox';
      box.setAttribute('data-sdb-pick-box', '');
      box.checked = !!v.available;
      box.disabled = !v.available;
      box.dataset.variant = v.id;
      box.dataset.price = v.price;
      box.dataset.qty = qty;
      label.appendChild(box);

      var media = document.createElement('div');
      media.className = 'sdb__pickMedia' + (it.product.image ? '' : ' sdb__media--empty');
      if (it.product.image) {
        var img = document.createElement('img');
        img.src = it.product.image; img.alt = it.product.title; img.loading = 'lazy';
        media.appendChild(img);
      }
      label.appendChild(media);

      var body = document.createElement('div');
      body.className = 'sdb__pickBody';

      var kat = document.createElement('span');
      kat.className = 'sdb__pickKat';
      kat.textContent = it.kat;
      body.appendChild(kat);

      var title = document.createElement('a');
      title.className = 'sdb__pickTitle';
      title.href = it.product.url || '#';
      title.target = '_blank';
      title.rel = 'noopener';
      var vt = (v.title && v.title !== 'Default Title') ? ' · ' + v.title : '';
      title.textContent = (qty > 1 ? qty + '× ' : '') + it.product.title + vt;
      body.appendChild(title);

      var price = document.createElement('div');
      price.className = 'sdb__pickPrice';
      price.textContent = v.available ? formatMoney(v.price * qty, self.moneyFormat) : 'Nicht verfügbar';
      body.appendChild(price);

      label.appendChild(body);
      self.productsEl.appendChild(label);
    });

    if (this.bulkEl) this.bulkEl.hidden = false;
    this.updateSum();
  };

  Sdb.prototype.updateSum = function () {
    var boxes = this.root.querySelectorAll('[data-sdb-pick-box]');
    var sum = 0, n = 0;
    Array.prototype.forEach.call(boxes, function (b) {
      if (b.checked) {
        var qty = Number(b.dataset.qty) || 1;
        sum += (Number(b.dataset.price) || 0) * qty;
        n++;
      }
    });
    var sumEl = this.root.querySelector('[data-sdb-bulk-sum]');
    if (sumEl) sumEl.textContent = formatMoney(sum, this.moneyFormat);
    var btn = this.root.querySelector('[data-sdb-bulk-atc]');
    if (btn) btn.disabled = n === 0;
  };

  Sdb.prototype.addSelected = function (button) {
    var self = this;
    var boxes = this.root.querySelectorAll('[data-sdb-pick-box]');
    var items = [];
    Array.prototype.forEach.call(boxes, function (b) {
      if (b.checked) items.push({ id: Number(b.dataset.variant), quantity: Number(b.dataset.qty) || 1 });
    });
    if (!items.length) return;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    var rootPath = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error('cart'); return res.json(); })
      .then(function () {
        button.textContent = '✓ Hinzugefügt';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]');
        Array.prototype.forEach.call(bubbles, function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { button.textContent = 'Fehler – erneut versuchen'; })
      .finally(function () {
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = original;
          self.updateSum();
        }, 2400);
      });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sdb-root]'), function (root) {
      if (root.dataset.sdbInit === 'true') return;
      if (!root.querySelector('[data-sdb-step]')) return;
      root.dataset.sdbInit = 'true';
      new Sdb(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
